module.exports = __webpack_public_path__ + "img/zoom-plus.c4922db1.svg";